module.exports = __webpack_public_path__ + "static/media/E.38974ecc.png";